import * as React from "react";
import "./reconciliationModal.scss"
import CurrencyHelper from "../../../../../helper/CurrencyHelper";
import LinkPresenter from "../../../../accounting/LinkPresenter";
import BillPaymentSummary from "../../../../../model/bill/BillPaymentSummary";
import BillSummary from "../../../../../model/bill/BillSummary";
import Routes from "../../../../../navigation/route/Route";

interface IProps {
	bill: BillSummary | BillPaymentSummary;
	showUndoReconciliation: boolean
	onUndoReconciliationClick: () => void;
}

export const BillInfo: React.SFC<IProps> = (props) => {
	let due: number, billId: string;
	if (props.bill instanceof BillPaymentSummary) {
		due = props.bill.paymentAmount;
		billId = props.bill.billId;
	}
	else {
		due = props.bill.due;
		billId = props.bill.id;
	}
	return <>
		<div className="c-reconciliation-modal_payment-container_details-container">
			<div>
				<span>Reference #</span>
				<span>Partner name</span>
				<span>Amount due</span>
				<span>Reference</span>
			</div>
			<div className="c-reconciliation-modal_payment-container_details-container_values-container invoice-details">
				<span>
					<LinkPresenter label={props.bill.referenceNumber} url={Routes.BillDetailsView(billId)}/>
				</span>
				<span>{props.bill.partnerName}</span>
				<span>{CurrencyHelper.toCurrency(due)}</span>
				<span>{props.bill.referenceNumber}</span>
			</div>
		</div>
		{props.showUndoReconciliation &&
		<div className="c-reconciliation-modal_undo-link invoice-info" onClick={props.onUndoReconciliationClick}>
			Undo reconciliation
		</div>}
	</>
};
